import { createSlice } from "@reduxjs/toolkit";

interface InitialState {
  products: ProductType[];
  categories: CategoriesType[];
  salesLoading: boolean;
  brandsLoading: boolean;
  acessoApp: boolean;
  loading: boolean;
}

const initialState: InitialState = {
  products: [],
  categories: [],
  salesLoading: false,
  brandsLoading: false,
  acessoApp: false,
  loading: true,
};

const productsSlice = createSlice({
  name: "products",
  initialState,
  reducers: {
    setProducts: (state, action) => {
      const products = action.payload.products || [];

      const productsWithDiscount = products.filter(
        (p: ProductType) => p.price !== p.standard_price
      );
      const productsWithoutDiscount = products.filter(
        (p: ProductType) => p.price === p.standard_price
      );

      productsWithDiscount.sort((a: ProductType, b: ProductType) => {
        const discountA =
          ((a.standard_price - a.price) / a.standard_price) * 100;
        const discountB =
          ((b.standard_price - b.price) / b.standard_price) * 100;
        return discountB - discountA;
      });

      productsWithoutDiscount.sort((a: ProductType, b: ProductType) => {
        return b.standard_price - a.standard_price;
      });

      const sorted = [...productsWithDiscount, ...productsWithoutDiscount];

      return {
        ...state,
        products: sorted,
        categories: action.payload.categories,
        acessoApp: action.payload.acessoApp || false,
        loading: false,
      };
    },
    setLoading: (state, action) => {
      state.salesLoading = action.payload;
    },
    setLoadingBrands: (state, action) => {
      state.brandsLoading = action.payload;
    },
  },
});

export const { actions, reducer } = productsSlice;
